import API from '../api'
import putUrl from './paths'

export const creditApprovalAction = ({ action, creditApprovalId, memberUserId = null, remarks = '' }) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.creditApprovalAction, {}, { action, creditApprovalId, memberUserId, remarks })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => reject(err))
	})

export const creditApprovalActionAll = ({ action, creditApprovalIds, memberUserId = null, remarks = '' }) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.creditApprovalActionAll, [...(creditApprovalIds || [])], { action, memberUserId, remarks })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => reject(err))
	})
